import { keymap } from "./constants.mjs";
export const isKey = (key, e) => {
  const keyCode = e.key || e.keyIdentifier || e.keyCode;
  return keymap[key].indexOf(keyCode) !== -1;
};
